import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Segment,
  Header,
  Message,
  Label,
  Icon,
  Button,
  Divider
} from "semantic-ui-react";

import { confirmadasOps } from "../../ducks/confirmadas";
import { documentacionOps } from "../../ducks/documentacion";

import FormularioInscripcion from "./inscripcionConfirmada/FormularioInscripcion";
import isEmpty from "lodash/isEmpty";
import ModalConfirm from "../shared/ModalConfirm";
import Adjunto from "./inscripcionConfirmada/Adjunto";
import DocumentUploader from "../adjuntarDocumentacion/DocumentUploader";

class InscripcionConfirmada extends React.Component {
  state = {
    idColegio: null,
    idInscripcion: null,
    showMessage: this.props.dataSaved.status,
    saveMessage: this.props.dataSaved.message,
    colorMessage: "pink",
    iconMessage: "check",
    sizeMessage: "big",
    labelClicked: true,
    showModalConfirm: false
  };

  componentDidMount() {
    const {
      match: {
        params: { idColegio, idInscripcion }
      }
    } = this.props;
    this.setState({ idColegio, idInscripcion });
    this.props.obtenerDatosInscripcion({
      idColegio,
      idInscripcion
    });
    this.props.obtenerDatosColegio(idColegio);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      showMessage: nextProps.dataSaved.status,
      saveMessage: nextProps.dataSaved.message,
      resguardo: nextProps.dataSaved.resguardo
    });

    nextProps.dataSaved.status &&
      this.props.obtenerDatosInscripcion({
        idColegio: this.props.match.params.idColegio,
        idInscripcion: this.props.match.params.idInscripcion
      });

    nextProps.dataSaved.status &&
      setTimeout(() => this.props.resetSavedData(), 2000);
  }

  componentWillUnmount() {
    this.props.limpiarDatosInscripcion();
    this.props.limpiarDatosColegio();
    this.setState({
      showMessage: false,
      saveMessage: "",
      resguardo: null
    });
  }

  handleGuardarInscripcion = values =>
    this.props.guardarCambiosInscripcion({
      values,
      idColegio: this.state.idColegio,
      idInscripcion: this.state.idInscripcion
    });

  handleClickFormaDePago = () =>
    this.setState(state => ({
      showModalConfirm: true,
      labelClicked: !state.labelClicked
    }));

  handleFormaDePago = ({ idInscripcion, formaDePago }) => {
    this.setState({ showModalConfirm: false });
    this.props.cambiarFormaDePago({
      idColegio: this.props.match.params.idColegio,
      idInscripcion,
      formaDePago
    });
  };

  handleModalCancel = () => this.setState({ showModalConfirm: false });

  handleVolver = () => {
    const {
      history,
      match: { params }
    } = this.props;
    history.push(`/inscripciones-confirmadas/${params.idColegio}`);
  };

  handleShowFileUploader = () =>
    this.setState(state => ({
      showFileUploader: !state.showFileUploader
    }));

  handleUploadFile = file => {
    this.props.clearUploadComplete();
    this.props.uploadFile({
      file,
      resguardo: this.props.match.params.idInscripcion,
      idColegio: this.props.match.params.idColegio,
      confirmada: true
    });

    setTimeout(() => this.props.clearUploadComplete(), 1000);
  };

  handleBorrarAdjunto = data =>
    this.props.borrarAdjunto({
      ...data,
      idColegio: this.state.idColegio,
      idInscripcion: this.state.idInscripcion,
      confirmada: true
    });

  renderAdjuntos = () => {
    const { adjuntos } = this.props.datosInscripcion;
    const rutas = adjuntos ? Object.values(adjuntos) : [];
    const ids = adjuntos ? Object.keys(adjuntos) : [];

    return rutas.map((ruta, index) => (
      <Adjunto
        key={ids[index]}
        id={ids[index]}
        url={ruta.url}
        fileName={ruta.fileName}
        handleBorrarAdjunto={this.handleBorrarAdjunto}
      />
    ));
  };

  render() {
    const {
      match: { params },
      datosInscripcion
    } = this.props;
    return (
      <Transition.Group animation="scale" duration={150}>
        {!isEmpty(datosInscripcion) && (
          <Container>
            <Transition.Group animation="fly down" duration={500}>
              {this.state.showMessage && (
                <Segment
                  basic
                  style={{
                    left: "40%",
                    position: "fixed",
                    top: "15%",
                    zIndex: 1000
                  }}
                >
                  <Message
                    size={this.state.sizeMessage}
                    color={this.state.colorMessage}
                  >
                    {this.state.saveMessage}
                    <Icon name={this.state.iconMessage} />
                  </Message>
                </Segment>
              )}
            </Transition.Group>

            <Segment basic>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />

              <Header inverted as="h2">
                Inscripción del Colegio {this.props.datosColegio.nombre}
              </Header>
            </Segment>

            <Segment>
              <Label
                basic
                size="big"
                content="Nº Resguardo:"
                detail={params.idInscripcion}
              />
              <Transition
                animation="pulse"
                duration={250}
                visible={this.state.labelClicked}
              >
                <Label
                  basic
                  size="big"
                  icon="euro"
                  content="Forma de Pago:"
                  className="aristas-pointer"
                  detail={this.props.datosInscripcion.formaDePago.toUpperCase()}
                  onClick={this.handleClickFormaDePago}
                />
              </Transition>

              <Divider />
              <Segment>
                <Header as="h3" content="Ficheros Adjuntos" />
                <Button
                  color="pink"
                  content={
                    this.state.showFileUploader ? "Ocultar" : "Adjuntar Fichero"
                  }
                  icon="add"
                  onClick={this.handleShowFileUploader}
                />

                {this.state.showFileUploader && (
                  <DocumentUploader
                    handleUploadFile={this.handleUploadFile}
                    procesoEnvio={this.props.procesoEnvio}
                    uploadComplete={this.props.uploadComplete}
                  />
                )}
                {this.renderAdjuntos()}
              </Segment>
              <Divider />

              <FormularioInscripcion
                initialValues={this.props.datosInscripcion}
                guardarCambios={this.handleGuardarInscripcion}
                precios={this.props.datosColegio.precios}
                provincia={this.props.datosColegio.provincia}
              />
            </Segment>
            <ModalConfirm
              open={this.state.showModalConfirm}
              idInscripcion={this.state.idInscripcion}
              handleCancelarModal={this.handleModalCancel}
              handleFormaDePago={this.handleFormaDePago}
            />
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  datosInscripcion: state.confirmadas.datosInscripcion,
  datosColegio: state.confirmadas.datosColegio,
  dataSaved: state.confirmadas.dataSaved,
  uploadComplete: state.documentacion.uploadComplete,
  procesoEnvio: state.documentacion.procesoEnvio
});

const mapDispatchToProps = {
  obtenerDatosInscripcion: confirmadasOps.obtenerDatosInscripcion,
  obtenerDatosColegio: confirmadasOps.obtenerDatosColegio,
  limpiarDatosColegio: confirmadasOps.limpiarDatosColegio,
  limpiarDatosInscripcion: confirmadasOps.limpiarDatosInscripcion,
  guardarCambiosInscripcion: confirmadasOps.guardarCambiosInscripcion,
  resetSavedData: confirmadasOps.resetSavedData,
  cambiarFormaDePago: confirmadasOps.cambiarFormaDePago,
  clearUploadComplete: documentacionOps.clearUploadComplete,
  uploadFile: documentacionOps.uploadFile,
  borrarAdjunto: documentacionOps.borrarAdjunto
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InscripcionConfirmada);



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/InscripcionConfirmada.jsx